import React from 'react';

import { ADMIN_INTEGRATIONS } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { IntegrationIcon } from '@Generic/icons';
import INTGERATIONS_PAGE_TABS from '../../../pages/Admin/IntegrationsPage/tabs';

const IntegrationsPage = React.lazy(() => import('../../../pages/Admin/IntegrationsPage'));

const PERMITTED_INTEGRATION_TAB_IDS = INTGERATIONS_PAGE_TABS.map((x) => x.id).join('|');

export default {
  label: 'admin-page.integrations-page.title',
  group: ADMIN,
  to: '/administration/integrations-page',
  route: [
    '/administration/integrations-page',
    `/administration/integrations-page/:tabId(${PERMITTED_INTEGRATION_TAB_IDS})`,
  ],
  component: IntegrationsPage,
  icon: <IntegrationIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_INTEGRATIONS,
  area: ADMIN_INTEGRATIONS,
  hasNavBar: true,
};
